import React from 'react';

export function BlockInsight({ insight }) {
    if (!insight) return null;

    const getSentimentClass = (sentiment) => {
        switch (sentiment) {
            case 'positive':
                return 'insight--positive';
            case 'negative':
                return 'insight--negative';
            case 'neutral':
            default:
                return 'insight--neutral';
        }
    };

    const getSentimentIcon = (sentiment) => {
        switch (sentiment) {
            case 'positive':
                return 'fa-arrow-up';
            case 'negative':
                return 'fa-arrow-down';
            case 'neutral':
            default:
                return 'fa-minus';
        }
    };

    return (
        <div className={`block-insight ${getSentimentClass(insight.sentiment)}`}>
            <div className="insight-icon">
                <i className={`fa ${getSentimentIcon(insight.sentiment)}`}></i>
            </div>
            <div className="insight-content">
                {insight.observation && (
                    <p className="insight-observation">
                        <strong>Observacion:</strong> {insight.observation}
                    </p>
                )}
                {insight.recommendation && (
                    <p className="insight-recommendation">
                        <strong>Recomendacion:</strong> {insight.recommendation}
                    </p>
                )}
            </div>
        </div>
    );
}
